import { render, staticRenderFns } from "./TabConsumerSection.vue?vue&type=template&id=515d4e27&"
import script from "./TabConsumerSection.vue?vue&type=script&lang=js&"
export * from "./TabConsumerSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports